module.exports = {
  "switch-container": {
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "switch-bar": {
    "position": "relative",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "container": {
    "borderRadius": "20",
    "height": "10"
  },
  "selected": {
    "backgroundColor": "#00A4F2"
  },
  "unselected": {
    "backgroundColor": "#e5e5e8"
  },
  "switch-icon": {
    "position": "absolute",
    "top": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-121d10da!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-switch-bar/index.vue
// module id = 422
// module chunks = 0 1